import { render } from "./EditFoodLimitComponent.vue?vue&type=template&id=4d3dfde4&scoped=true"
import script from "./EditFoodLimitComponent.vue?vue&type=script&lang=js"
export * from "./EditFoodLimitComponent.vue?vue&type=script&lang=js"

import "./EditFoodLimitComponent.vue?vue&type=style&index=0&id=4d3dfde4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3dfde4"]])

export default __exports__